import SpriteSymbol from "../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-up",
  "use": "icon-up-usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol class=\"icon\" viewBox=\"0 0 1024 1024\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" id=\"icon-up\"><path d=\"M951.1626 819.412438 72.8374 819.412438 511.999488 204.586538Z\" p-id=\"2889\" fill=\"#2F318B\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol